import { render } from "./Posw2ComprasView.vue?vue&type=template&id=a6690810&scoped=true"
import script from "./Posw2ComprasView.vue?vue&type=script&lang=js"
export * from "./Posw2ComprasView.vue?vue&type=script&lang=js"

import "./Posw2ComprasView.vue?vue&type=style&index=0&id=a6690810&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6690810"]])

export default __exports__